import { useState } from 'react';

export default function RenderAQuestion({ question }) {
    const [isSelectingOption, setIsSelectingOption] = useState(false);
    const [selectedArea, setSelectedArea] = useState(null);
    return (
        <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{background:"linear-gradient(to top, #fff, #F0FBFF)"}}>
            <div>{question?.question}</div>
            {
            question.type === '座標題1' ?
                <div className='p-[8px] rounded-[8px] flex flex-row gap-[8px]'>
                    <div className='flex flex-1 flex-col bg-white items-center gap-[4px]' style={{boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                        <div>豁達／平靜</div>
                        <div className='flex flex-row w-full items-center gap-[4px]'>
                            <div>逃避／出世 </div>
                            <div className='flex flex-col flex-1 gap-[4px] relative'>
                                <div className='flex flex-row w-full gap-[4px]'>
                                    <button className='flex-1 bg-[#82828240]' style={{aspectRatio: '17 / 12',height:undefined}} onClick={()=>{
                                        if(isSelectingOption){
                                            setSelectedArea(1);
                                             setIsSelectingOption(false);
                                        }
                                    }}>
                                         {isSelectingOption&&<div className='glowingAnimation w-full h-full'/>}
                                         {selectedArea === 1 && !isSelectingOption && 
                                            <button className='px-[20px] py-[8px] rounded-[8px]' style={{backgroundColor: '#EE8D59', color: 'white'}}>歐陽修</button>
                                        }
                                    </button>
                                    <button className='flex-1 bg-[#82828240]' style={{aspectRatio: '17 / 12',height:undefined}} onClick={()=>{
                                        if(isSelectingOption){
                                            setSelectedArea(2);
                                             setIsSelectingOption(false);
                                        }
                                    }}>
                                         {isSelectingOption&&<div className='glowingAnimation w-full h-full'/>}
                                         {selectedArea === 2 && !isSelectingOption && 
                                            <button className='px-[20px] py-[8px] rounded-[8px]' style={{backgroundColor: '#EE8D59', color: 'white'}}>歐陽修</button>
                                        }
                                    </button>
                                </div>
                                <div className='flex flex-row w-full gap-[4px]'>
                                    <button className='flex-1 bg-[#82828240]' style={{aspectRatio: '17 / 12',height:undefined}} onClick={()=>{
                                        if(isSelectingOption){
                                            setSelectedArea(3);
                                             setIsSelectingOption(false);
                                        }
                                    }}>
                                        {isSelectingOption&&<div className='glowingAnimation w-full h-full'/>}
                                        {selectedArea === 3 && !isSelectingOption && 
                                            <button className='px-[20px] py-[8px] rounded-[8px]' style={{backgroundColor: '#EE8D59', color: 'white'}}>歐陽修</button>
                                        }
                                    </button>
                                    <button className='flex-1 bg-[#82828240]' style={{aspectRatio: '17 / 12',height:undefined}} onClick={()=>{
                                        if(isSelectingOption){
                                            setSelectedArea(4);
                                            setIsSelectingOption(false);
                                        }
                                    }}>
                                        {isSelectingOption&&<div className='glowingAnimation w-full h-full'/>}
                                        {selectedArea === 4 && !isSelectingOption && 
                                            <button className='px-[20px] py-[8px] rounded-[8px]' style={{backgroundColor: '#EE8D59', color: 'white'}}>歐陽修</button>
                                        }
                                    </button>
                                </div>
                                {isSelectingOption&&<div className='absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-[#EE8D59] bg-[white]'>點擊選擇區域</div>}
                            </div>
                            <div>面對／入世</div>
                        </div>
                        <div>悲憤／孤傲</div>
                    </div>
                    <div className='px-[8px]'>
                        <button onClick={()=>{setIsSelectingOption(!isSelectingOption)}} className='px-[20px] py-[8px] rounded-[8px]' style={{backgroundColor: isSelectingOption ? '#EE8D59' : '#82828240', color: isSelectingOption ? 'white' : 'black'}}>歐陽修</button>
                    </div>
                </div>
                :
            question.type === '選擇題' ?
                <div className='p-[8px] rounded-[8px] flex flex-col gap-[8px]'>
                    {question.options?.map((option, idx) => (
                        <div key={idx} className='w-full rounded-full bg-[white]' style={{boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                            <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[6px] flex flex-row items-center noto-san-hk'>
                                <button style={{width:25, height:25,borderRadius: '99px', border: '2px solid #005B8C'}}/>
                                <span>{option.option}</span>
                            </div>
                        </div>
                    ))}
                </div>
                :
                <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
            }
            <div className='flex flex-row justify-end'>
                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                    儲存
                </button>
            </div>
        </div>
    )
}